import React from 'react';
import { Checkbox } from '@progress/kendo-react-inputs';

/**
 * A base Checkbox component.
 *
 * @typedef {React.ComponentProps<Checkbox>} TelerikCheckboxProps
 *
 * @param {TelerikCheckboxProps} props Component props. Extends Telerik Checkbox props.
 * @returns {React.ReactElement}
 */
const BaseCheckbox = (props) => <Checkbox {...props} />;

export default BaseCheckbox;
